import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {DataObject} from '../models/data-object.model';

// needed to instantiate a DataObject child class in generalized methods
export type Newable<T> = new (...args: any[]) => T;

@Injectable()
export abstract class PersistenceService {

    // generics can't create new instance of type T in typescript
    // => pass instance of type that should be created
    // DataObject: Patient, Measurement, Annotation,...

    public abstract list<T extends DataObject>(type: Newable<T>): Observable<T[]>;

    public abstract get<T extends DataObject>(id: string, type: Newable<T>): Observable<T>;

    public abstract create(data: DataObject): Observable<void>;

    public abstract update(data: DataObject): Observable<any>;

    public abstract delete(id: string, type: Newable<DataObject>): Observable<any>;

}
